import { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react'
import { ClientInfo } from '../api-clients/api-types'
import { getClientInfo } from '../api-clients/eba-clients'
import { useAccessToken } from '../api-clients/client-hooks'

interface ClientInfoContextProps {
  children: ReactNode
}
const defaultClientInfo = { hasSensitiveAccess: undefined } as unknown as ClientInfo
const ClientInfoContext = createContext<ClientInfo>(defaultClientInfo)

export const useClientInfo = () => {
  return useContext(ClientInfoContext)
}

export const ClientInfoProvider: FC<ClientInfoContextProps> = ({ children }) => {
  const getAccessToken = useAccessToken()
  const [clientInfo, setClientInfo] = useState<ClientInfo>(defaultClientInfo)
  useEffect(() => {
    const initRoles = async () => {
      const clientInfoResponse = await getAccessToken()
        .then((token) => getClientInfo({ token }))
        .then((response) => (response.contentType === 'json' ? response.json : defaultClientInfo))
        .catch((_) => {
          return defaultClientInfo
        })
      setClientInfo(clientInfoResponse)
    }

    if (clientInfo.hasSensitiveAccess === undefined) {
      initRoles()
    }
  }, [clientInfo, setClientInfo, getAccessToken])

  return <ClientInfoContext.Provider value={clientInfo}>{children}</ClientInfoContext.Provider>
}

export default ClientInfoContext
